import axios from 'axios'
import config from './config'
const firebase = window.firebase

/**
 * Retrieve a campaign configuration
 * @param {string} pixelId
 */
function list (pixelId) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(authToken => {
      return axios
        .get(`${config.API_BASE_URL}/admin/campaign`, {
          params: {
            pixelId,
            authToken
          }
        })
        .then(res => {
          return res.data
        })
    })
}

/**
 * Update a pixel configuration
 * @param {string} pixelId
 * @param {string} campaignid
 * @param {object} data
 */
function update (pixelId, campaignId, data) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(authToken => {
      return axios
        .patch(`${config.API_BASE_URL}/admin/campaign`, {
          pixelId,
          campaignId,
          authToken,
          config: data
        })
    })
}

export default {
  list,
  update
}



// WEBPACK FOOTER //
// ./src/api/campaign.js